import React from 'react';

import {SeasonalIndicator, SeasonalIndicators} from '../../lib/api/eval';

function Indicator({indicator}: {indicator: SeasonalIndicator | null | undefined}) {
  if (!indicator) {
    return <span className="text-gray-400 text-xs">&mdash;</span>;
  }

  const isPositive = indicator.pctDiff >= 0;
  const arrow = isPositive ? '\u25B2' : '\u25BC';
  const colorClass = isPositive ? 'text-green-600' : 'text-red-500';
  const sign = isPositive ? '+' : '';

  return (
    <span className={`text-xs font-medium ${colorClass}`}>
      {arrow} {indicator.label} {sign}
      {Math.round(indicator.pctDiff)}%
    </span>
  );
}

export default function SeasonalIndicatorsMini({data}: {data?: SeasonalIndicators}) {
  if (!data || (data.flow == null && data.swe == null)) {
    return (
      <div
        className="flex items-center justify-center text-xs text-gray-400"
        style={{minWidth: 180}}
      >
        No seasonal data
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3" style={{minWidth: 180}}>
      <Indicator indicator={data.flow} />
      <Indicator indicator={data.swe} />
    </div>
  );
}
